import usePrivateAxios from "@/common/api/usePrivateAxios";
import { UseQueryOptions, UseQueryResult, useQuery } from "@tanstack/react-query";
import { EquipmentData, EquipmentResponse } from "../types/equipments.type";
import { AxiosError } from "axios";

type UseEquipmentProps = {
  id: string;
  options?: Partial<Omit<UseQueryOptions<EquipmentResponse, AxiosError, EquipmentData>, 'select' | 'queryKey' | 'queryFn'>>
};

type UseEquipmentType = ({ }: UseEquipmentProps) => UseQueryResult<EquipmentData, AxiosError>;

const useEquipment: UseEquipmentType = ({ id, options }) => {
  const privateAxios = usePrivateAxios();

  return useQuery<EquipmentResponse, AxiosError, EquipmentData>({
    queryKey: ['equipment', id],
    queryFn: () => {
      return privateAxios.get(`/equipments/${id}`);
    },
    select: (data) => data?.data?.data,
    ...options,
  });
};

export default useEquipment;
